import styled from 'styled-components';

const SizesFilterWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export default SizesFilterWrapper;
